import React from 'react';
import { ToastContainer } from 'react-toastify';
import Routers from './Routes';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <>
      <Analytics />
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
